import React from "react";
import SwisscardLogo from "../../../../../resources/images/scd-header-logo.svg";
import SwisscardLogoSmall from "../../../../../resources/images/scd-header-logo-xs.svg";

import "./styles.scss";

export default function Logo(): React.JSX.Element {
  return (
    <>
      <div className="scd-header-logo">
        <img src={SwisscardLogo} alt={"Swisscard"} />
      </div>
      <div className="scd-header-logo scd-header-logo-xs">
        <img src={SwisscardLogoSmall} alt={"Swisscard"} />
      </div>
    </>
  );
}
